import { render, staticRenderFns } from "./OilGoods.vue?vue&type=template&id=f5f6acbe&scoped=true&"
import script from "./OilGoods.vue?vue&type=script&lang=js&"
export * from "./OilGoods.vue?vue&type=script&lang=js&"
import style0 from "./OilGoods.vue?vue&type=style&index=0&id=f5f6acbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f6acbe",
  null
  
)

export default component.exports